import { getJobSceneSets } from '@apis/simulation';
import { useAbortableFetch } from './useAbortableFetch';

/** 单 Job 场景集树；enabled=false（对比模式 / Daily 差异筛选）时不请求并清空。 */
export function useSceneSetStats(jobId: number, enabled: boolean) {
  const fetcher = enabled && jobId && !Number.isNaN(jobId)
    ? (signal: AbortSignal) => getJobSceneSets(jobId, signal)
    : null;
  return useAbortableFetch(fetcher, [jobId, enabled], '加载场景集统计失败');
}
